export default {
  dashboard: "Dashboard",
  company: "Bedrijven",
  person: "Contacten",
  invoice: "Facturen",
  product: "Producten",
}
